




























































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import PartnersConnectionsFilter from "@/components/Settings/PartnersConnections/PartnersConnectionsFilter.vue";
import { PartnerConnectionItem } from "@/store/settings/partners_connections/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({ components: {PartnersConnectionsFilter, ScrollButton} })
export default class PartnersConnections extends BaseItemsPage<PartnerConnectionItem> {

  @Getter("partnersConnections") partnersConnectionsResponse: any;

  is_show_filter = false;
  currentSort= "name";
  currentSortOrder= "desc";
  tableFields = ['partner', 'broker_account', 'connection_type', 'protocol', 'transport', 'status_duration'];

  getData(): any {
    return this.partnersConnectionsResponse;
  }
}
